export default __webpack_public_path__ + "static/media/contextapi.c5a1a786.png";